module.exports = __webpack_public_path__ + "src/assets/img/stop.9fe45f02.svg";